/*
  Cart value entries ladder bar.

  Liquid draws the bar and decides whether the giveaway window is open.
  This file only keeps the numbers live while the shopper edits the cart.

  Two rules worth remembering before changing anything here.

  1. The tier is decided on the cart subtotal BEFORE any discount, read from
     [data-cart-original-total]. That is the same basis the ANCHOR order_paid
     Flow uses (the sum of lineItems[].originalTotalSet.shopMoney.amount), so
     the cart and the entries award always agree. Never fall back to
     data-cart-total: that one is after discounts and would drop a tier the
     moment a customer used one of our own codes.

  2. That attribute lives inside [data-cart-price-holder], which the theme
     replaces wholesale on every cart change, so it must be read fresh each
     time. Caching the element would leave us holding a detached node.

  The update signal is the theme's own theme:cart:change event, dispatched by
  build() in theme.js after the new cart HTML is already in the page. Do not
  hook fetch here: assets/custom.js already patches window.fetch for the
  per line entries properties and fires extra /cart/change.js calls of its own.
*/

(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-cart-ladder]';

  /* Shop currency to presentment currency. Same source the theme uses for the
     free shipping limit, because the ladder tiers are stored in shop currency
     while cart.original_total_price is rendered in presentment currency. */
  function currencyRate() {
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) {
      return parseFloat(window.Shopify.currency.rate) || 1;
    }
    return 1;
  }

  function formatMoney(cents) {
    var theme = window.theme;
    if (theme && typeof theme.formatMoney === 'function' && theme.moneyFormat) {
      return theme.formatMoney(Math.round(cents), theme.moneyFormat).replace('.00', '');
    }
    return (Math.round(cents) / 100).toFixed(2);
  }

  function replaceToken(text, name, value) {
    return text.split('||' + name + '||').join(value);
  }

  function strong(value) {
    return '<b>' + value + '</b>';
  }

  function readConfig(root) {
    var holder = root.querySelector('[data-cart-ladder-config]');
    if (!holder) return null;
    try {
      return JSON.parse(holder.textContent);
    } catch (error) {
      return null;
    }
  }

  function readCart() {
    var el = document.querySelector('[data-cart-original-total]');
    if (!el) return null;
    var subtotal = parseInt(el.getAttribute('data-cart-original-total'), 10);
    var count = parseInt(el.getAttribute('data-cart-item-count'), 10);
    if (isNaN(subtotal)) return null;
    return { subtotal: subtotal, count: isNaN(count) ? 0 : count };
  }

  /* Highest tier at or below the subtotal wins, and tiers never stack.
     config.tiers is already sorted low to high by Liquid, so one pass does it. */
  function resolveTiers(tiers, subtotal, rate) {
    var current = null;
    var next = null;
    var top = null;

    for (var i = 0; i < tiers.length; i++) {
      var tier = {
        amount: Math.round(tiers[i].amount * rate),
        multiplier: tiers[i].multiplier
      };
      top = tier;
      if (subtotal >= tier.amount) {
        current = tier;
      } else if (next === null) {
        next = tier;
      }
    }

    return { current: current, next: next, top: top };
  }

  function buildMessage(config, state) {
    var currentLabel = strong((state.current ? state.current.multiplier : 1) + 'x');

    if (state.next) {
      var text = state.current ? config.messageNext : config.messageStart;
      text = replaceToken(text, 'amount', strong(formatMoney(state.next.amount - state.subtotal)));
      text = replaceToken(text, 'next', strong(state.next.multiplier + 'x'));
      return replaceToken(text, 'current', currentLabel);
    }

    return replaceToken(config.messageTop, 'current', currentLabel);
  }

  function render(root) {
    var config = readConfig(root);
    var cart = readCart();
    if (!config || !cart || !config.tiers || !config.tiers.length) return;

    if (config.hideWhenEmpty && cart.count === 0) {
      root.classList.add('is-hidden');
      return;
    }
    root.classList.remove('is-hidden');

    var rate = currencyRate();
    var state = resolveTiers(config.tiers, cart.subtotal, rate);
    state.subtotal = cart.subtotal;

    var track = root.querySelector('[data-cart-ladder-track]');
    if (track && state.top && state.top.amount > 0) {
      var percent = Math.min(100, (cart.subtotal * 100) / state.top.amount);
      track.style.setProperty('--ladder-percent', percent.toFixed(2) + '%');
    }

    /* Tick positions are ratios of the top tier, so the currency rate cancels
       out and Liquid can place them once. Only the reached state changes. */
    var ticks = root.querySelectorAll('[data-cart-ladder-tick]');
    for (var i = 0; i < ticks.length; i++) {
      var amount = Math.round(parseInt(ticks[i].getAttribute('data-cart-ladder-tick'), 10) * rate);
      ticks[i].classList.toggle('is-reached', !isNaN(amount) && cart.subtotal >= amount);
    }

    var message = root.querySelector('[data-cart-ladder-message]');
    if (message) message.innerHTML = buildMessage(config, state);

    root.classList.remove('is-pending');
  }

  function refresh() {
    var roots = document.querySelectorAll(ROOT_SELECTOR);
    for (var i = 0; i < roots.length; i++) render(roots[i]);
  }

  document.addEventListener('theme:cart:change', refresh);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();
